import axios from "../axios";
import {
    ISystemNoticeAddParams,
    ISystemNoticeDeleteParams,
    ISystemNoticeQueryListData,
    ISystemNoticeQueryPageData,
    ISystemNoticeQueryPageParams,
    ISystemNoticeReadParams
} from "./systemNotice.types";


/**
 *  删除
 */
export function systemNoticeDelete(params: ISystemNoticeDeleteParams) {
    return axios({
        method: 'delete',
        url: '/systemNotice',
        params
    })
}

/**
 *  添加
 */
export function systemNoticeAdd(params: ISystemNoticeAddParams) {
    return axios({
        method: 'post',
        url: '/systemNotice/add',
        data: params
    })
}

/**
 *  查询发布中的系统消息
 */
export function systemNoticeQueryList() {
    return axios<ISystemNoticeQueryListData>({
        method: 'get',
        url: '/systemNotice/queryList',
    })
}

/**
 *  系统消息-分页
 */
export function systemNoticeQueryPage(params: ISystemNoticeQueryPageParams) {
    return axios<ISystemNoticeQueryPageData>({
        method: 'get',
        url: '/systemNotice/queryPage',
        params
    })
}

/**
 *  已读系统消息
 */
export function systemNoticeRead(params: ISystemNoticeReadParams) {
    return axios({
        method: 'get',
        url: `/systemNotice/readNotice/${params.id}`,
    })
}
